import { Component, EventEmitter, OnDestroy, OnInit, Output, ViewChild, ViewEncapsulation, ElementRef } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatAccordion, MatRadioChange, MatDatepicker } from '@angular/material';
import { fuseAnimations } from '@fuse/animations';
import { CustomValidators } from 'ngx-custom-validators';
import { Subject } from 'rxjs';
import { CotizadorService } from '../../services/cotizador.service';
import { isNil } from 'lodash';
import { Prospecto } from '../../models/prospecto';


@Component({
  selector: 'app-prospecto',
  templateUrl: './prospecto.component.html',
  styleUrls: ['./prospecto.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations
})
export class ProspectoComponent implements OnInit, OnDestroy {

  @ViewChild('pickerProspecto') pickerProspecto: MatDatepicker<any>;
  @ViewChild('pickerMancomunado') pickerMancomunado: MatDatepicker<any>;
  @ViewChild('edadMancomunado') edadMancomunadoInput: ElementRef;
  @ViewChild('edadProspecto') edadProspectoInput: ElementRef;
  @ViewChild('prospectoNombre') prospectoNombreInput: ElementRef;
  @ViewChild('mancomunadoNombre') mancomunadoNombreInput: ElementRef;


  @Output() CambiaTab = new EventEmitter<number>();
  private unsubscribeAll: Subject<any>;

  public prospectoForm: FormGroup;

  public mancomunadoForm: FormGroup;
  deshabilitarMancomunado = true;
  seleccionoMancomunado = false;
  mostrarEdadProspecto = true;
  mostrarEdadMancomunado = true;

  panelOpenState = false;

  masculino = false;
  femenino = false;
  genero: string;
  generos: string[] = ['Masculino', 'Femenio'];

  // Valores minimo y maximo para evitar traslape de fechas.
  anioEnCurso;
  anioMinimoValido;
  anioMaximoValido;
  minDate;
  maxDate;

  edadOFechaSeleccionadaProspecto = false;
  edadOFechaSeleccionadaMancomunado = false;

  /**
   *
   * @param formBuilder provee de funciones y objetos para la creacion y validaciÃ³n de formas.
   */
  constructor(
    private formBuilder: FormBuilder,
    private cotizadorService: CotizadorService
  ) {
    this.unsubscribeAll = new Subject();
  }

  /**
   * Este metodo se ejecuta al inciar el componente Creamos el formulario
   */
  ngOnInit(): void {

    // Valores minimo y maximo para evitar traslape de fechas.
    this.anioEnCurso = (new Date()).getFullYear();
    this.anioMinimoValido = this.anioEnCurso - 70;
    this.anioMaximoValido = this.anioEnCurso - 18;
    this.minDate = new Date(this.anioMinimoValido, 0, 1);
    this.maxDate = new Date(this.anioMaximoValido, 0, 1);

    this.prospectoForm = this.formBuilder.group({
      nombre: new FormControl(null, [Validators.required, CustomValidators.rangeLength([3, 40])]),
      //nombre: new FormControl('Carlos Grover'),
      genero: new FormControl('H', [Validators.required]),
      edad: new FormControl(null, [CustomValidators.min(18), CustomValidators.max(70)]),
      //edad: new FormControl('24'),
      fechaNac: new FormControl({ value: null, disabled: true }),
      habito: new FormControl('NO', [Validators.required])
    });

    this.mancomunadoForm = this.formBuilder.group({
      nombre: new FormControl(null, [Validators.required, CustomValidators.rangeLength([3, 40])]),
      genero: new FormControl('H', [Validators.required]),
      edad: new FormControl(null, [CustomValidators.min(18), CustomValidators.max(70)]),
      fechaNac: new FormControl({ value: null, disabled: true }),
      habito: new FormControl('NO', [Validators.required])
    });

    // Nos subscribimos a los cambios de la edad para ver si es una fecha valida.
    this.prospectoForm.controls.edad.valueChanges.subscribe(valorEdad => {
      if (valorEdad >= 18 && valorEdad <= 70) {
        this.edadOFechaSeleccionadaProspecto = true;
      } else {
        this.edadOFechaSeleccionadaProspecto = false;
      }
    });

    // Validamos que seleccione o fecha o numerico.
    this.prospectoForm.controls.fechaNac.valueChanges.subscribe(fechaCambiada => {
      if (!isNil(fechaCambiada)) {
        this.edadOFechaSeleccionadaProspecto = true;
      } else {
        this.edadOFechaSeleccionadaProspecto = false;
      }
    });

    // Nos subscribimos a los cambios de la edad para ver si es una fecha valida.
    this.mancomunadoForm.controls.edad.valueChanges.subscribe(valorEdad => {
      if (valorEdad >= 18 && valorEdad <= 70) {
        this.edadOFechaSeleccionadaMancomunado = true;
      } else {
        this.edadOFechaSeleccionadaMancomunado = false;
      }
    });

    // Validamos que seleccione o fecha o numerico.
    this.mancomunadoForm.controls.fechaNac.valueChanges.subscribe(fechaCambiada => {
      if (!isNil(fechaCambiada)) {
        this.edadOFechaSeleccionadaMancomunado = true;
      } else {
        this.edadOFechaSeleccionadaMancomunado = false;
      }
    });

    setTimeout(() => {
      this.prospectoNombreInput.nativeElement.focus();
    }, 10);

  }

  /**
   * Inicializamos los valores del formulario.
   */
  inicializaFormulario(): any {
    this.prospectoForm.setValue({
      nombre: '',
      genero: '',
      edad: '',
      fechaNac: '',
      habito: '',
      planMalcumunado: '',
      mancomunadoForm: null
    });

    this.prospectoForm.reset();
    this.prospectoForm.updateValueAndValidity();
  }

  /**
   * Emitimos los datos generales del prospecto para cualquier componente,
   * Emmitimos el prospecto para cualquier componente y
   * Emitimos evento para cambiar el tab del padre. 
   */
  seleccionarProspecto(): void {
 //debugger;
    if (this.prospectoForm.invalid) {
      return;
    }
   

    let prospect: Prospecto = this.prospectoForm.value;
 

    prospect.nombreMancomunado =this.mancomunadoForm.controls.nombre.value;
    prospect.edadMancomunado =this.mancomunadoForm.controls.edad.value;
    prospect.generoMancomunado =this.mancomunadoForm.controls.genero.value;
    prospect.habitoMancomunado =this.mancomunadoForm.controls.habito.value;

    if (this.prospectoForm.controls.fechaNac.value) {
      let edad = this.getEdad(this.prospectoForm.controls.fechaNac.value);
      prospect.edad = edad + '';
    }
    prospect.formaPago= 'ANUAL'; 
    this.cotizadorService.setProspecto(prospect);
    this.CambiaTab.emit(1);
  }

  /** 
   * Este mÃ©todo se ejecuta cuando el componente es destruido y eliminamos las subscripciones que esten activas.
   */
  ngOnDestroy(): void {
    this.unsubscribeAll.next();
    this.unsubscribeAll.complete();
  }


  /**
   * 
   * @param event 
   */
  edadOFechaProspecto(event: MatRadioChange): void {debugger;
    if (event.value === '1') {
      this.mostrarEdadProspecto = true;
      this.prospectoForm.controls.fechaNac.setValue(null);

      setTimeout(() => {
        this.edadProspectoInput.nativeElement.focus();
      }, 10);
    } else {
      this.prospectoForm.controls.edad.setValue(null);
      this.mostrarEdadProspecto = false;

      setTimeout(() => {
        if (!isNil(this.pickerProspecto)) {
          this.pickerProspecto.open();
        }
      }, 10);
    }

  }

  /**
  * 
  * @param event 
  */
  edadOFechaMancomunado(event: MatRadioChange): void {
    if (event.value === '1') {
      this.mostrarEdadMancomunado = true;
      this.mancomunadoForm.controls.fechaNac.setValue(null);

      setTimeout(() => {
        this.edadMancomunadoInput.nativeElement.focus();
      }, 10);
    } else {
      this.mancomunadoForm.controls.edad.setValue(null);
      this.mostrarEdadMancomunado = false;

      setTimeout(() => {
        if (!isNil(this.pickerMancomunado)) {
          this.pickerMancomunado.open();
        }
      }, 10);
    }
  }

  /**
   * 
   * @param event 
   */
  planMancomunadoRadio(event: MatRadioChange): void {

    if (event.value === '1') {
      this.deshabilitarMancomunado = false;
      this.seleccionoMancomunado = true;

      setTimeout(() => {
        this.mancomunadoNombreInput.nativeElement.focus();
      }, 10);
    } else {
      this.deshabilitarMancomunado = true;
      this.seleccionoMancomunado = false;
    }
  }


  /**
   * Cuando cambia la seleccion del plan mancomunado entonces abrimos o cerramos los datos del mancomunado.
   */
  planMancomunado(matChange: MatRadioChange): void {
  }

  getEdad(fechaNacimiento): number {
    return ~~((Date.now() - fechaNacimiento || Date.now()) / (24 * 3600 * 365.25 * 1000));
  }
}
